import { TagType } from '@/constants/tags'
import type { TagModelValue } from '@/types/components/tags'
import type { AssetInfoTag } from '@/types/services/assets'
import type { Tag, TagTypeValue } from '@/types/services/tags'

export function convertTagValueToTag(
  value: TagModelValue,
  entity_id: string,
  type: TagTypeValue = TagType.TAG
): Tag {
  return {
    entity_id,
    type,
    ...value,
  }
}

export function groupTagsByType(tags: Tag[]): Record<TagTypeValue, Tag[]> {
  const result = {} as Record<TagTypeValue, Tag[]>

  // Initialize each tag type with an empty array
  Object.values(TagType).forEach((type) => {
    result[type] = []
  })

  // Add tags to their respective types
  tags.forEach((tag) => {
    result[tag.type].push(tag)
  })

  return result
}

export function isParentAssetInfoTag(tag: AssetInfoTag): boolean {
  return (
    tag.account_id == null && tag.asset_type == null && tag.source_id == null
  )
}
